import MediaBox from './mediabox.js';
export default {
  init: function()
  {
    if (!document.getElementById("single-main-change-story-content"))
    {
      return;
    }
    this.changePopup();
  },
  /**
   * youtube video popup and right side sticky media
   */
  changePopup: function()
  {

    //MediaBox is youtube popup
    MediaBox('.mediabox');

    //Sticky nav and right image
    function fixedStoryMenu()
    {
      if ($('.single-page.single-change-story-content .article-content .terms-list').length)
      {
        var element = $(".single-page.single-change-story-content .article-content .terms-list");
        var element_height = element.height();
        var element_top = element.offset().top;

        if ($(window).width() > 260)
        {
          $(window).scroll(function()
          {

            // console.clear();
            var scrollTop = $(window).scrollTop();

            if ($(window).scrollTop() >= (element_top + element_height))
            {
              $(".fixed-navigation, .single-change-story-content").addClass("show");
            }
            else
            {
              $(".fixed-navigation, .single-change-story-content").removeClass("show");
            }

          });
        }

      }
    }

    if (document.getElementById("single-main-change-story-content")) {
      fixedStoryMenu();
      var $width         = window.innerWidth;
      var winPos         = $(window).scrollTop();
      var sideBar       = $('.media-holder');
      //var sidebarTopPos = $('.media-holder').offset().top - 30;
      var sideBarIMG = $('.media-holder img').height();
      var sideBarImgPos = sideBarIMG + sideBarIMG;
      var sideBarImgWidth = $('.media-holder img').width();
      var articleContent = $('.article-content');
      var articleTopPos = $('.article-content').offset().top;
      var articleBottom = $('.article-content').offset().top + $('.article-content').outerHeight(true);
      var articleBottomPos = articleBottom - sideBarImgPos;
      var isScrolling = false;
      if ($('#max-img-scroll').length) {
        var scrolltoDiv = $('#max-img-scroll').offset().top;
      }
      function setSidebarBanners(isScrolling, scroll) {
        sideBarIMG = $('.media-holder img').height();
        sideBarImgPos = sideBarIMG + sideBarIMG;
        articleContent = $('.article-content');
        articleTopPos = $('.article-content').offset().top;
        articleBottom = $('.article-content').offset().top + $('.article-content').outerHeight(true);
        articleBottomPos = articleBottom - sideBarImgPos;
        if (window.matchMedia("(min-width: 992px)").matches) {
            if (!sideBar.hasClass('sidebar-not-fixed')) {
                if (isScrolling) {
                    if (scroll >= articleTopPos) {
                        sideBar.addClass('sidebar-fixed');
                    } else {
                        sideBar.removeClass('sidebar-fixed');
                    }
                } else {
                    if (winPos >= articleTopPos) {
                        sideBar.addClass('sidebar-fixed');
                    } else {
                        sideBar.removeClass('sidebar-fixed');
                    }
                }
            }
        } else {
            sideBar.removeClass('sidebar-fixed');
        }
      }
      setSidebarBanners(isScrolling, 0);
      $('.single-page.single-change-story-content .media-holder .featured-img').css('max-width', sideBarImgWidth+'px');
        jQuery(window).resize(function() {
          var scrollResize          = $(window).scrollTop();
          sideBarImgWidth = $('.media-holder img').width();
          $('.single-page.single-change-story-content .media-holder .featured-img').css('max-width', sideBarImgWidth+'px');
          if (scrollResize >= articleTopPos) {
            setSidebarBanners(true, scrollResize);
          } else {
            setSidebarBanners(isScrolling, 0);
          }
      });
      if (winPos >= scrolltoDiv) {
        sideBar.addClass('hide-el');
      } else {
        sideBar.removeClass('hide-el');
      }
      $(window).scroll(function (event) {
        var scroll          = $(window).scrollTop();
        if ($('#max-img-scroll').length) {
          scrolltoDiv = $('#max-img-scroll').offset().top;
        }
        var $scrollContainer = $('.single-change-story-content > .main-story-content');
        setSidebarBanners(true, scroll);
        if (scroll >= scrolltoDiv) {
          sideBar.addClass('hide-el');
        } else {
          sideBar.removeClass('hide-el');
        }
        if (scroll >= articleTopPos) {
          if (!$scrollContainer.hasClass('isFixed')){
            $('.single-change-story-content > .main-story-content').addClass('isFixed');
          }
        } else {
          if ($scrollContainer.hasClass('isFixed')){
            $('.single-change-story-content > .main-story-content').removeClass('isFixed');
          }
        }
      });
    }

  }
}